export function isOnline(): boolean {
  return typeof window !== 'undefined' ? window.navigator.onLine : true;
}
